<template>
	<!-- 
<Panel :title="" :loading="<true/false>">
</Panel>
【传参说明】
title：卡片名称
loading：是否展示加载效果，默认true
styleType：用于实现特殊排版,可用传参见props说明
more：点击跳转url或执行方法
 -->
	<div v-if="display" class="panel bgPanel ps-out-t ps-out-b" :class="[styleType]">
		<div v-if="title" class="head w100pct ms-in-b ps-out-l ps-out-r posR">
			<div class="title w60pct-max fsLv3">
				<span>{{ title }}</span>
				<slot name="title"></slot>
			</div>
			<div class="tool taR posA fSub_E hover-f-primary_E ms-in-l_E dpIB_E vaM_E">
				<slot name="tool"></slot>
				<router-link v-if="more" :to="'string,object'.indexOf(getValType(more)) >= 0 ? more : ''" class="more boxR-light tra-fast" @click.native="clickMore"
					><Icon :name="'more'" class="w2x h2x" type="singlecolor"
				/></router-link>
			</div>
		</div>
		<div class="content pl2x pr2x posR">
			<loading v-if="loading"></loading>
			<slot></slot>
		</div>
	</div>
</template>
<script>
import * as lib from "@/util/lib";
import Loading from "@/components/common/ui/Loading.vue";

export default {
	name: "",
	components: {Loading},
	props: {
		title: {
			type: String,
			default: "",
		},
		size: {
			//大小尺寸控制
			type: String,
			default: "",
		},
		loading: {
			//加载状态的展示
			type: Boolean,
			default: true,
		},
		styleType: {
			//样式风格："coverFull"
			type: String,
			default: "",
		},
		more: {
			type: [Function, String, Object],
			default: "",
		},
	},
	data() {
		return {
			display: true,
			dynamic: null,
		};
	},
	watch: {},
	created() {},
	methods: {
		getValType: $.type,
		show: function () {},
		clickMore: function () {
			if ($.type(this.more) == "function") {
				this.more();
				this.$emit("More");
			}
		},
	},
	computed: {},
	mounted() {},
	destroyed() {},
};
</script>
<style lang="scss" scoped>
.tool {
	margin: {
		top: -2rem;
	}
	top: 50%;
	right: 1em;
	.more {
		width: 4rem;
		height: 4rem;
		line-height: 4rem;
		text-align: center;
		background: rgba(128, 128, 128, 0.06);
	}
}
/*其它场景样式*/
.coverFull {
	padding: {
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}
	.head {
		margin: {
			top: 1em;
		}
		padding: {
			left: 1em;
		}
		position: absolute;
		z-index: 1;
	}
	.content {
		padding: {
			right: 0;
			left: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Panel.vue